<template>
    <div :class="{'nullOrLoadingPosition': !relative, 'nullOrLoading': relative,}" v-if="listData.length === 0 || loading">
        <section style="height: 100%;" class="indexJust">
            <noData v-if="listData.length === 0 && !loading" :img-size="imgSize"></noData>
            <loadingModule v-if="loading"></loadingModule>
        </section>
    </div>
</template>

<script>
import noData from '@/components/module/noData/index.vue';
import loadingModule from '@/components/module/loading/loading.vue';
export default {
    props: {
        listData: [],
        loading: false,
        relative: false,
        imgSize: {
            type: Number,
            default: 120,
        }
    },
    data() {
        return {

        }
    },
    components: {
        noData,
        loadingModule
    },
}
</script>

<style lang="scss">
.nullOrLoadingPosition {
  width: 100%;
  height: calc(100% - 62px);
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 100;
}

.nullOrLoading {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/module/noDataOrLoading/index.vue